import React from 'react';

import {
	ApChip,
	ApIcon,
	colors,
	ApButtonSecondary,
} from '@alixpartners/ui-components';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { SettingsContext } from 'contexts/SettingsContext';
import { serializeQueryParams } from 'utils/api';
import { createStoredQuery, fetchStoredQuery } from 'utils/apiRequests';
import { convertToArray, EMPTY_VALUE } from 'Details/utils';
import { FilterRow } from './FilterRow';
import { NavFilter } from 'components/NavFilter';
import {
	StyledMenu,
	Wrapper,
	NoData,
	ListWrapper,
	TitleWraper,
	Label,
	Footer,
	CounterWrapper,
} from './OtherFilters.styles';
import AgDropDown from './AgDropDown';
const CUSTOM_FILTERS_QUERY_STRING_LIMIT = 2000;

export class OtherFilters extends React.Component {
	state = {
		isOpen: false,
		isFullHeight: false,
		searchQuery: '',
		selectedFilter: null,
		localSelected: [],
	};

	toggleMenu = isOpen => {
		this.setState({ isOpen });
	};

	setFullHeight = isFullHeight => {
		this.setState({ isFullHeight });
	};

	setSearchQuery = searchQuery => {
		this.setState({ searchQuery });
	};

	componentDidMount() {
		this.fetchStoredFilters();
	}

	componentDidUpdate(prevProps) {
		const { storedQueryId, setQueryStringState } = this.props;

		if (!storedQueryId && !!prevProps.storedQueryId) {
			setQueryStringState({
				storedQuery: null,
			});
		} else if (storedQueryId !== prevProps.storedQueryId) {
			this.fetchStoredFilters();
		}
	}

	async fetchStoredFilters() {
		const { storedQueryId, setQueryStringState } = this.props;

		if (storedQueryId) {
			const query = await fetchStoredQuery(storedQueryId);

			const customFilters = query
				.filter(item => item.key === 'filters')
				.map(item => item.value);
			const customFiltersValues = query
				.filter(item => item.key === 'filterValues')
				.map(item => item.value);

			setQueryStringState({
				storedQuery: {
					customFilters,
					customFiltersValues,
				},
			});
		}
	}

	getCustomFilters() {
		const { storedQueryId, storedQuery } = this.props;
		let { customFiltersValues, customFilters } = this.props;

		if (storedQueryId) {
			if (storedQuery) {
				({ customFiltersValues, customFilters } = storedQuery);
			} else {
				customFiltersValues = [];
				customFilters = [];
			}
		}

		return { customFiltersValues, customFilters };
	}

	closeFilter = () => {
		this.setState({ selectedFilter: null });
	};

	selectFilter = filter => {
		this.setState({ selectedFilter: filter, searchQuery: '' });
	};

	clearAll = () => {
		const { setQueryStringStateAndPush, setQueryStringState } = this.props;

		setQueryStringState({ storedQuery: undefined });

		setQueryStringStateAndPush({
			storedQueryId: undefined,
			customFiltersValues: [],
			customFilters: [],
		});
	};

	updateFilters = async queryParams => {
		const { setQueryStringStateAndPush, setQueryStringState } = this.props;
		const locationHref =
			(window && window.location && window.location.href) || '';
		// TODO: use logic to serialize all qury url
		const isQueryParamsExceeded =
			`${locationHref}&${serializeQueryParams({
				filterValues: [...queryParams.customFiltersValues],
				filters: [...queryParams.customFilters],
			})}`.length > CUSTOM_FILTERS_QUERY_STRING_LIMIT;

		if (isQueryParamsExceeded) {
			// store query
			const requestParams = [
				...queryParams.customFilters.map(value => ({
					key: 'filters',
					value,
				})),
				...queryParams.customFiltersValues.map(value => ({
					key: 'filterValues',
					value,
				})),
			];

			const { id: storedQueryId } = await createStoredQuery(requestParams);

			// save filters to store here - to prevent un-needed GET request
			setQueryStringState({ storedQuery: queryParams });

			// clear filters here if storedQueryId
			setQueryStringStateAndPush({
				storedQueryId,
				customFiltersValues: [],
				customFilters: [],
			});
		} else {
			// clear stored filters
			setQueryStringState({ storedQuery: undefined });

			// save filters to query params
			setQueryStringStateAndPush({ ...queryParams, storedQueryId: undefined });
		}
	};

	onFilterChange = (selectedItems, name) => {
		const { selectedFilter } = this.state;
		const { customFilters, customFiltersValues } = this.getCustomFilters();
		const filterName = name || selectedFilter.name;

		const existingFiltersWithoutCurrent = customFilters
			.map((filterName, index) => ({
				name: filterName,
				value: customFiltersValues[index],
			}))
			.filter(({ name }) => name !== filterName);

		const newFilters = [
			...existingFiltersWithoutCurrent,
			...selectedItems.map(filterValue => ({
				name: filterName,
				value: filterValue,
			})),
		];
		this.updateFilters({
			customFilters: newFilters.map(({ name }) => name),
			customFiltersValues: newFilters.map(({ value }) => value),
		});
	};

	getCustomFiltersList = () => {
		const { options } = this.props;
		const { searchQuery } = this.state;
		const activeFilters = options
			? options.filter(({ isActive }) => isActive)
			: [];

		if (!searchQuery) {
			return activeFilters;
		}

		return activeFilters.filter(item =>
			item.label.toLowerCase().includes(searchQuery.toLowerCase())
		);
	};

	getSelectedItems(name) {
		const { customFilters, customFiltersValues } = this.getCustomFilters();
		const { selectedFilter } = this.state;
		const filterName = name || selectedFilter.name;
		const isActiveFilter = customFilters.includes(filterName);
		const currentValues = isActiveFilter
			? customFilters
					.map((filterName, index) => ({
						name: filterName,
						value: customFiltersValues[index] || '',
					}))
					.filter(({ name }) => name === filterName)
					.map(({ value }) => value)
			: [];
		return currentValues;
	}

	getCurrentOptions = () => {
		const { selectedFilter } = this.state;

		if (!selectedFilter) {
			return [];
		}

		return selectedFilter.values.map(({ value, label }) => ({
			label: label || EMPTY_VALUE,
			value: value || '',
		}));
	};

	onMenuClose = () => {
		this.setSearchQuery('');
		this.closeFilter();
	};

	getOtherFiltersSelectedCount = () => {
		const { customFilters } = this.getCustomFilters();
		const { predefinedFilters } = this.props;

		if (!predefinedFilters || predefinedFilters.length === 0) {
			return customFilters.length;
		}

		const predefinedFilterNames = predefinedFilters.map(item => item.name);

		return customFilters.filter(
			filter => !predefinedFilterNames.includes(filter)
		).length;
	};
	handleChange = value => {
		let newSelected = [];

		if (this.getSelectedItems().includes(value)) {
			newSelected = this.getSelectedItems().filter(item => item !== value);
		} else {
			newSelected = [...this.getSelectedItems(), value];
		}

		this.setState({ localSelected: newSelected }, () =>
			this.onFilterChange(value)
		);
	};

	render() {
		const { predefinedFilters, order } = this.props;
		const { isOpen, isFullHeight, searchQuery, selectedFilter } = this.state;
		const filtersList = this.getCustomFiltersList();
		const overallSelectedCount = this.getOtherFiltersSelectedCount();

		return (
			<React.Fragment>
				{predefinedFilters &&
					predefinedFilters.length &&
					predefinedFilters.map(
						({ name, values, label, order }) =>
							!!values && (
								<NavFilter
									key={name}
									onChange={selectedItems =>
										this.onFilterChange(selectedItems, name)
									}
									selected={this.getSelectedItems(name)}
									name={name}
									label={label}
									options={values.map(item => ({ label: item, value: item }))}
									order={order}
								/>
							)
					)}
				<StyledMenu
					button={
						<div style={{ width: 'fit-content', position: 'relative', order }}>
							{!!overallSelectedCount && (
								<CounterWrapper>{overallSelectedCount}</CounterWrapper>
							)}
							<ApChip
								icon="filter_outlined"
								small
								selected={isOpen || !!overallSelectedCount}
							>
								Other filters
							</ApChip>
						</div>
					}
					placement="bottom-end"
					toggleMenu={this.toggleMenu}
					onClose={this.onMenuClose}
					isOpen={isOpen}
					isFullHeight={isFullHeight}
				>
					<Wrapper>
						{!selectedFilter ? (
							<React.Fragment>
								{filtersList.length === 0 ? (
									<NoData>No results found</NoData>
								) : (
									<ListWrapper>
										{filtersList.map((item, index) => {
											const selectedCount = this.getSelectedItems(item.name)
												.length;

											return (
												<div
													key={index}
													onClick={() => this.selectFilter(item)}
												>
													<FilterRow
														searchQuery={searchQuery}
														label={item.label}
														count={selectedCount}
													/>
												</div>
											);
										})}
									</ListWrapper>
								)}
								<Footer>
									<ApButtonSecondary onClick={this.clearAll} small>
										Clear other filters
									</ApButtonSecondary>
								</Footer>
							</React.Fragment>
						) : (
							<React.Fragment>
								<TitleWraper onClick={this.closeFilter}>
									<ApIcon
										iconName="baseline_arrow_back"
										iconColor={colors.grey7}
									/>
									<Label>{selectedFilter.label}</Label>
								</TitleWraper>
								<AgDropDown
									selectedFilter={selectedFilter.columnName}
									handleChange={this.handleChange}
									selectedItems={this.getSelectedItems()}
								/>
							</React.Fragment>
						)}
					</Wrapper>
				</StyledMenu>
			</React.Fragment>
		);
	}
}

export default props => (
	<SettingsContext.Consumer>
		{({ customFilters: options }) => (
			<QueryStringContext.Consumer>
				{({
					setQueryStringStateAndPush,
					setQueryStringState,
					customFilters,
					customFiltersValues,
					storedQueryId,
					storedQuery,
				}) => (
					<OtherFilters
						{...props}
						options={options}
						customFilters={convertToArray(customFilters)}
						customFiltersValues={convertToArray(customFiltersValues)}
						setQueryStringStateAndPush={setQueryStringStateAndPush}
						setQueryStringState={setQueryStringState}
						storedQueryId={storedQueryId}
						storedQuery={storedQuery}
					/>
				)}
			</QueryStringContext.Consumer>
		)}
	</SettingsContext.Consumer>
);
